import React from 'react';
import { Button } from '../../../components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription
} from '../../../components/ui/dialog';
import { Settings, X } from 'lucide-react';

export function ConfigOperacoesModal({
  open, onOpenChange, configOperacoes, operacoesDisponiveis,
  onRemove, onAdd, onSave
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Settings className="h-5 w-5 text-amber-600" />Configurar Operacoes Sugeridas
          </DialogTitle>
          <DialogDescription>
            Defina quais operacoes aparecem como sugestoes ao criar novas tarefas pontuais.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">
              Operacoes Sugeridas ({configOperacoes.length})
            </label>
            {configOperacoes.length === 0 ? (
              <div className="p-4 bg-stone-50 rounded-lg border border-dashed border-stone-200 text-center">
                <p className="text-sm text-stone-500">Nenhuma operacao configurada</p>
                <p className="text-xs text-stone-400 mt-1">Selecione operacoes abaixo para adicionar</p>
              </div>
            ) : (
              <div className="space-y-2">
                {configOperacoes.map((op, idx) => (
                  <div key={idx} className="flex items-center gap-2 p-2 bg-amber-50 rounded-lg border border-amber-200">
                    <span className="font-mono text-xs font-bold px-2 py-0.5 bg-amber-100 text-amber-700 rounded">{op.operacao_codigo}</span>
                    <span className="text-sm flex-1">{op.operacao_nome}</span>
                    <Button variant="ghost" size="sm" className="h-6 w-6 p-0 text-red-500 hover:text-red-700" onClick={() => onRemove(idx)}>
                      <X className="h-3 w-3" />
                    </Button>
                  </div>
                ))}
              </div>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-stone-700 mb-2">Adicionar Operacao</label>
            <input type="text" placeholder="Pesquisar operacao..."
              className="w-full px-3 py-2 border border-stone-200 rounded-lg text-sm mb-2 focus:outline-none focus:ring-2 focus:ring-amber-400"
              data-testid="search-operacoes-sugeridas"
              onChange={(e) => {
                const searchVal = e.target.value.toLowerCase();
                const list = document.querySelectorAll('[data-testid="op-sugerida-item"]');
                list.forEach(item => { item.style.display = item.textContent.toLowerCase().includes(searchVal) ? '' : 'none'; });
              }}
            />
            <div className="max-h-64 overflow-y-auto border rounded-lg">
              {(() => {
                const ops = operacoesDisponiveis
                  .filter(op => !configOperacoes.some(c => c.operacao_id === op.id))
                  .sort((a, b) => (a.categoria || '').localeCompare(b.categoria || '') || (a.codigo || '').localeCompare(b.codigo || ''));
                const grupos = {};
                ops.forEach(op => { const cat = op.categoria || 'Sem Categoria'; if (!grupos[cat]) grupos[cat] = []; grupos[cat].push(op); });
                return Object.entries(grupos).map(([cat, opsGrupo]) => (
                  <div key={cat}>
                    <p className="text-xs font-bold uppercase text-stone-400 tracking-wider px-2 py-1.5 bg-stone-50 sticky top-0 border-b">{cat}</p>
                    {opsGrupo.map(op => (
                      <button key={op.id} type="button" onClick={() => onAdd(op)}
                        className="w-full flex items-center gap-2 p-2 hover:bg-stone-50 border-b last:border-b-0 text-left text-sm"
                        data-testid="op-sugerida-item">
                        <span className="font-mono text-xs text-primary font-bold">{op.codigo}</span>
                        <span className="flex-1 truncate">{op.nome}</span>
                      </button>
                    ))}
                  </div>
                ));
              })()}
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
            <Button onClick={onSave} className="bg-amber-600 hover:bg-amber-700">
              <Settings className="h-4 w-4 mr-2" />Guardar Configuracao
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
